import { Member, MemberRole } from 'src/features/member/types'
import { Trial, TrialHospital } from 'src/features/trial/types'
import { ApiResponse } from 'src/lib/api-client'
import { isPermission } from 'src/lib/permission'
import { castUid } from 'src/utils/brandedUid'

import { Account } from '../types'

export const parseAccountResponse = (
  res: ApiResponse<'GetUserResponse'>,
  mfaEnabled: boolean,
): Account => {
  const base: Account = {
    uid: castUid<Account>(res.uid),
    firstName: res.first_name,
    lastName: res.last_name,
    email: res.email,
    mfaEnabled,
    hasMultipleMemberships: res.has_multiple_memberships,
    hasSelectedTrial: false,
    loginMethod: res.login_method,
  }

  if (!res.selected_trial) {
    return base
  }

  return {
    ...base,
    hasSelectedTrial: true,
    selectedTrialHospitalUid: !!res.selected_trial.selected_trial_hospital_uid
      ? castUid<TrialHospital>(res.selected_trial.selected_trial_hospital_uid)
      : null,
    selectedTrialHospitalRole: !!res.selected_trial.selected_trial_hospital_role
      ? res.selected_trial.selected_trial_hospital_role
      : null,
    member: {
      uid: castUid<Member>(res.selected_trial.trial_member_uid),
      firstName: res.first_name,
      lastName: res.last_name,
      role: parseMemberRole(res.selected_trial.role),
      videoCallUserUid: res.selected_trial.video_call_user_uid,
    },
    selectedTrial: {
      uid: castUid<Trial>(res.selected_trial.uid),
      name: res.selected_trial.name,
      trialHospitals: res.selected_trial.trial_hospitals.map(th => ({
        uid: castUid<TrialHospital>(th.uid),
        name: th.name,
        role: th.role,
      })),
      newEconsentEnabled: res.selected_trial.new_econsent_enabled,
      eRecruitEnabled: res.selected_trial.erecruit_enabled,
      featureChannel: res.selected_trial.feature_channel,
      featureFlags: res.selected_trial.feature_flags,
    },
    permissions: res.selected_trial.permissions.filter(isPermission),
  }
}

const parseMemberRole = (role: number): MemberRole => {
  switch (role) {
    case 2:
      return 'DM'
    case 3:
      return 'CRA'
    case 4:
      return 'Dr'
    case 5:
      return 'CRC'
    case 6:
      return 'Viewer'
    default:
      throw new Error('invalid role')
  }
}
